import RepartitionData from "@/domain/entities/dashboard/RepartitionData";
import SmartLabel from "@/domain/enums/SmartLabel";
import { NavBarContent as NavBarContentSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const navbarDataToRepartitionDataMapper = (
    navbarData: NavBarContentSDK,
): RepartitionData[] =>
    navbarData.smartlabelNavItems.map(
        (smartLabel) =>
            new RepartitionData({
                id: smartLabel.id as SmartLabel,
                value: smartLabel.itemCount || 0,
            }),
    );

export default navbarDataToRepartitionDataMapper;
